var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.dark}},[_c('vue-dialog'),_c('router-view'),_c('div',{attrs:{"id":"v-console-container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }